import { Component, ViewContainerRef, inject, input, viewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';

import { RegisterComponent } from '../component-lookup';
import { ProductNavComponent } from '../product-nav/product-nav.component';
import { PeerSelectorComponent, PeerSelectorType } from '../peer-selector/peer-selector.component';
import { DateRangeSelectorComponent } from '../date-range-selector/date-range-selector.component';
import { DateSelectorComponent } from '../date-selector/date-selector.component';
import { RoomNavComponent } from '../room-nav/room-nav.component';
import { FeedbackService } from '../../../shared/services/feedback.service';
import { StateService } from '../../services/state.service';
import { UserService } from '../../../shared/services/user.service';
import { DialogService } from '../../../shared/services/dialog.service';
import { UpgradeDialogComponent } from '../upgrade-dialog/upgrade-dialog.component';

export enum DateSelectorType {
  dateRange = 1,
  date = 2
}

@RegisterComponent('ProductHeader')
@Component({
  selector: 'app-product-header',
  standalone: true,
  imports: [CommonModule, ProductNavComponent, PeerSelectorComponent, DateRangeSelectorComponent, DateSelectorComponent, RoomNavComponent],
  templateUrl: './product-header.component.html',
  styleUrl: './product-header.component.scss'
})
export class ProductHeaderComponent {
  dialog = viewChild('dialog', { read: ViewContainerRef });

  peerSelectorType = input<PeerSelectorType>(PeerSelectorType.all);
  dateSelectorType = input<DateSelectorType>(DateSelectorType.dateRange);
  feedback = input<boolean>(true);
  print = input<boolean>(true);
  currentProduct = input<string>('peer-comparison');

  private route = inject(ActivatedRoute);
  private feedbackService = inject(FeedbackService);
  private stateService = inject(StateService);
  private dialogService = inject(DialogService);

  readonly DateSelectorType = DateSelectorType;
  readonly isPrinting = this.stateService.isPrinting;
  readonly userProducts = inject(UserService).userProducts;

  onFeedback() {
    this.feedbackService.onFeedback(this.dialog());
  }

  onPrint() {
    // if (!this.userProducts().some(p => p.tierClientCode == 'peer-comparison-standard')) {
    //   this.dialogService.show(this.dialog(), UpgradeDialogComponent).subscribe();
    // }
    const url = `/print/${this.route.snapshot.url.join('/')}`;
    this.stateService.storePrintState(this.currentProduct() === 'peer-comparison');
    window.open(url, '_blank');
  }
}
